import React, { useState } from 'react';
import { supabase } from './supabase';

function Login({ onLogin, onSwitchToSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Sign in using Supabase Auth
      const { data, error: authError } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password: password
      });

      if (authError) {
        console.error('Full Auth Error:', authError);

        // Diagnostic check: Does this user exist in public.users but not Auth?
        try {
          const { data: publicUser } = await supabase
            .from('users')
            .select('email')
            .eq('email', email.trim())
            .maybeSingle();

          if (publicUser) {
            setError(`Account exists in database but not in Auth. (Code: ${authError.status}) - Please SIGN UP with this email to register it properly.`);
          } else if (authError.message === 'Email not confirmed') {
            setError('Email not confirmed. Please check your inbox for the verification link.');
          } else {
            setError(`${authError.message || 'Invalid email or password'} (Code: ${authError.status || 'unknown'})`);
          }
        } catch (diagError) {
          setError(`${authError.message || 'Invalid email or password'} (Code: ${authError.status || 'unknown'})`);
        }
        return;
      }

      const userData = data.user;

      // Auth state change will be handled by App.js listener
      onLogin();
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Welcome :)</h1>
          <p>Sign in to your Daily Mailbox</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                style={{ width: '100%', paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '1.2em'
                }}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
        <div className="auth-footer">
          <p>Don't have an account? <button onClick={onSwitchToSignup} className="link-button">Sign Up</button></p>
        </div>
      </div>
    </div>
  );
}

export default Login;
